import { createFileRoute } from '@tanstack/react-router'
import AdminTelegramPage from '@/spa/pages/admin/AdminTelegramPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/admin/telegram')({
  component: AdminTelegramPage,
  errorComponent: routeErrorComponent,
})
